import { useMutation, useQueryClient } from '@tanstack/react-query'
import { assignmentKeys } from './keys'
import { removeWorker } from 'api/assignment/removeWorker'
import { useAuthContext } from 'components/auth'

interface UseRemoveWorkerParams {
  assignmentId: number
  workerId: number
  shiftId: number
  onError?: (error: Error) => void
}

export const useRemoveWorker = ({
  assignmentId,
  workerId,
  shiftId,
  onError,
}: UseRemoveWorkerParams) => {
  const queryClient = useQueryClient()
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: (payload: Parameters<typeof removeWorker>[4]) => {
      if (!company?.id) {
        throw new Error('Company is required')
      }
      return removeWorker(company.id, assignmentId, workerId, shiftId, payload)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: assignmentKeys.detail.byId(assignmentId),
        refetchType: 'active',
      })
    },
    onError: onError,
  })
}
